import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { RecordsManager } from "../../modules/records/records-manager";
import { InputFormModel, ObjectFrom } from "../dynamic-form/models/input-form";
import { DynamicFormServices } from "../dynamic-form/services/dynamic-form.services";

@Component({
  selector: "app-table-cols-filter",
  templateUrl: "./table-cols-filter.component.html",
  styleUrls: ["./table-cols-filter.component.scss"],
})
export class TableColsFilterComponent<T extends object> implements OnInit {
  inputFormDisplay: ObjectFrom[] = [];
  displayOptionForm!: FormGroup;

  constructor(
    private recordsManager: RecordsManager<T>,
    private dynamicFormService: DynamicFormServices
  ) {}

  ngOnInit(): void {
    let displayOption: InputFormModel = {
      formControlName: "displayOption",
      label: "Display Options",
      placeholder: "Display Options",
      objectSelectBK: this.recordsManager.tableConfig?.cols.filter((col) => col.removable),
      validators: {},
      objectSelect: this.recordsManager.tableConfig?.cols.filter((col) => col.removable),
      //.map((col) => ({ key: col.columnDef })),
      template: "autocomplete",
      isMultipleSelect: true,
      viewValueSelect: "columnDef",
      keySelect: "columnDef",
      disabled: false,
      value: this.recordsManager.tableConfig?.cols
        .filter((col) => col.removable)
        .map((col) => col.columnDef),
      valueBK: this.recordsManager.tableConfig?.cols
        .filter((col) => col.removable)
        .map((col) => col.columnDef),
    };

    this.inputFormDisplay = [[displayOption]];

    this.displayOptionForm = this.dynamicFormService.generateFormGroup(this.inputFormDisplay);
    /*     this.displayOptionForm.controls['displayOption'].setValue([
      "surveyRequestId",
      "brand",
      "region",
      "market",
      "dealer",
      "vin",
      "customerName",
      "dealerName",
      "dataSurvey",
      "rpCreateBtn"
  ]) */

    this.displayOptionForm.controls["displayOption"].valueChanges.subscribe((data: string[]) => {
      this.recordsManager.toggleColVisibility(data);
    });
  }
}
